<template>
    <span class="vuetify-wrapper">
        <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-btn
                    v-on="on"
                    :disabled="disabled"
                    @click="autoPropose"
                    :loading="loading"
                    min-width="30"
                    small
                    outlined
                    :icon="false"
                    :outlined="false"
                    :title="title"
                >
                    <v-icon small color="green">mdi-email-fast</v-icon>
                </v-btn>
            </template>
            <span>
                {{ title }}
            </span>
        </v-tooltip>
    </span>
</template>

<script>

import axios from 'axios';
import { mapMutations } from 'vuex'

export default {
    name: 'AutoProposalButton',
    props: {
        appointment_id: String,
        is_auto_proposed: Boolean,
        is_chunk_data: Boolean,
        disabled: {
            default: false,
            type: Boolean,
        },
    },
    data: function() {
        return {
            loading: false,
        };
    },
    computed: {
        title() {
            if (this.is_auto_proposed) {
                if (this.is_chunk_data) {
                    return "Wurde bereits automatisch und manuell gesendet. Erneut senden?"
                }
                return "Wurde bereits gesendet. Keine Chunk-Historie vorhanden. Erneut senden?"
            }
            return "Diesen Termin automatisch Freiberuflern vorschlagen."
        }
    },
    methods: {
        async autoPropose() {
            this.loading = true;

            let resend = this.is_chunk_data && this.is_auto_proposed
            try {
                const response = await axios.get(`/api/appointments/${this.appointment_id}/enable_automated_proposals?resend=${resend}`);
                const payload = Array.isArray(response.data) ? response.data[0] : response.data;
                const payloadStatus = Array.isArray(response.data) ? response.data[1] : response.status;
                const errorMessage = payload?.error || payload?.message;
                if (payloadStatus >= 300 || errorMessage) {
                    this.alertError(errorMessage);
                    return;
                }
                if (payload) this.$emit("update", payload);
                this.alertSuccess('Autovorschläge erfolgreich gesendet.')
            }
            catch(error) {
                const message = error?.response?.data?.error || error?.response?.data?.message;
                this.alertError(message);
                console.warn("! failed to auto propose appointment", error)
            }
            finally {
                this.loading = false;
            }
        },
        ...mapMutations({
            alertError: 'alert/error',
            alertSuccess: 'alert/success',
        })
    }
};
</script>
